import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  HostBinding,
} from '@angular/core';
import { ElementStatus } from 'src/app/shared/enums';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.sass'],
})
export class AlertComponent implements OnChanges {
  @Input() message: string;
  @Input() type: ElementStatus = ElementStatus.Success;
  @Output() close = new EventEmitter<boolean>(false);
  icon: string;

  @HostBinding('class.success')
  get isSuccess(): boolean {
    return this.type === ElementStatus.Success;
  }

  @HostBinding('class.danger')
  get isDanger(): boolean {
    return this.type === ElementStatus.Danger;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.icon = this.getIcon(this.type);
  }

  closeEvent(evemt: Event) {
    this.close.emit(true);
  }

  getIcon(type: ElementStatus): string {
    switch (type) {
      case ElementStatus.Success:
        return 'check';
      case ElementStatus.Danger:
        return 'delete';
      default:
        return 'check';
    }
  }
}
